import React, {useEffect, useState} from "react";
import InputCheckbox from "../../../../../components/input/input-checkbox.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";

const DevolutionCellRenderer = ({data, setCautions}) => {
    const {id, quantity, quantity_selected} = data;
    const [quantityReturn, setQuantityReturn] = useState(data.quantityReturn ?? (quantity_selected ? 1 : ""));

    useEffect(() => {
        setQuantityReturn(data.quantityReturn ?? (quantity_selected ? 1 : ""));
    }, [data.quantityReturn, quantity_selected]);

    const onChangeCheckbox = ({target: {checked}}) => {
        const value = checked ? 1 : 0;
        data.quantityReturn = value;
        setQuantityReturn(value);
        if (setCautions) {
            setCautions(prev => prev.map(m => m.id === id ? ({...m, quantityReturn: value}) : m));
        }
    };

    const onChange = ({target: {value}}) => {
        data.quantityReturn = value;
        setQuantityReturn(value);
    };

    const onBlur = () => {
        if (setCautions) {
            setCautions(prev => prev.map(m => m.id === id ? ({...m, quantityReturn: data.quantityReturn}) : m));
        }
    };

    if (quantity === 1) {
        return (
            <div className={"flex items-center justify-center h-full"}>
                <InputCheckbox
                    id={`devolution-${id}`}
                    checked={!!quantity_selected || Number(quantityReturn) === 1}
                    label=""
                    onChange={onChangeCheckbox}
                />
            </div>
        );
    }

    return (
        <InputForm
            id={`devolution-quantity-${id}`}
            name="devolution-quantity"
            value={quantityReturn ?? ""}
            type={"number"}
            onChange={onChange}
            onBlur={onBlur}
            label=" "
            inputClass={"!h-[25px] bg-white mt-[1px]"}
        />
    );
};

export default DevolutionCellRenderer;